import 'scss/blog'
document.addEventListener("DOMContentLoaded", 
function(){
    initElement();
});
function initElement() {
    var searchButton = document.getElementById('btn__search-button');
    var closeButton = document.getElementById('btn__close-button');
    closeButton.onclick = closeSearchForm;
    searchButton.onclick = showSearchForm;
};
function showSearchForm(event) {
    event.preventDefault();
    var searchFormSection = document.getElementById('section__search-form');
    var closeButton = document.getElementById('btn__close-button');
    var searchButton = document.getElementById('btn__search-button');
    searchButton.classList.toggle("d-none")
    closeButton.classList.toggle("d-none");
    searchFormSection.classList.toggle("show");

}
function closeSearchForm(event) {
    event.preventDefault();
    var searchFormSection = document.getElementById('section__search-form');
    var closeButton = document.getElementById('btn__close-button');
    var searchButton = document.getElementById('btn__search-button');
    searchButton.classList.toggle("d-none");
    closeButton.classList.toggle("d-none");
    searchFormSection.classList.toggle("show");

}
